import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <h3> &copy; {year} RedDawg Tech LLC. All rights reserved. </h3>
          <a href="mailto:support@reddawgtech.com">
            support@reddawgtech.com
          </a>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
